import { getApiPathForProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";

export const getAllowedValuesExcelUrl = (provider: CrmIntegrationProvider): string =>
    `sales-api/${getApiPathForProvider(provider)}/mapping-field/allowed-values/excel`;
